import * as React from "react";

import { useCustomerSession, useJoinDrawerUserExperience } from "../../Common";

import { useMyBagPresentationModel } from "../providers";

export const RewardsCallout: React.FunctionComponent = () => {
  const { presentationMyBagOrder } = useMyBagPresentationModel();
  const { isCustomerLoggedIn } = useCustomerSession();

  const { handleBeginTheJoinDrawerUserExperience } =
    useJoinDrawerUserExperience();

  const shouldPresent = React.useMemo(() => {
    return !isCustomerLoggedIn;
  }, [isCustomerLoggedIn]);

  const memberSavings = React.useMemo(() => {
    const memberSavingsRealMoneyValue =
      presentationMyBagOrder?.orderValueByItemsBreakdown
        .memberDiscountPotential || 0;
    if (memberSavingsRealMoneyValue > 0) {
      return (
        <React.Fragment>
          <p className="memberSavings">
            <span className="members-save-">{`Members save `}</span>
            <span className="dollar-sign">{`\$`}</span>
            <span className="memberSavingsRealMoneyValue">
              {`${memberSavingsRealMoneyValue?.toFixed(2)}`}
            </span>
            <span className="on-this-order">{` on this order.`}</span>
          </p>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <p className="memberSavings">
            <span className="members-save-">{`Are you a member? Sign in for faster checkout.`}</span>
          </p>
        </React.Fragment>
      );
    }
  }, [presentationMyBagOrder]);

  const handleSignInToApply: React.MouseEventHandler<HTMLButtonElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();
        handleBeginTheJoinDrawerUserExperience();
      },
      [handleBeginTheJoinDrawerUserExperience]
    );

  if (!shouldPresent) {
    return null;
  }

  return (
    <section className="shipping-rewards-callout">
      <div className="decoration"></div>

      <div className="what-why">
        <img className="rewards-image" alt="REWARDS" />
        {memberSavings}
      </div>

      <div className="how">
        <button
          className="sign-in"
          onClick={handleSignInToApply}
        >{`SIGN IN`}</button>
      </div>
    </section>
  );
};
